import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const useReservationSchema = () => {
  const { t } = useTranslation();
  const dailyReservationScheme = yup.object().shape({
    fromDate: yup
      .date()
      .typeError(t("warning.text1"))
      .nullable()
      .required(t("warning.text2")),
    // .min(new Date(), "Date must be in the future"),
    numOfDays: yup
      .number()
      .typeError(t("warning.text3"))
      .nullable()
      .required(t("warning.text4"))
      .min(1, t("warning.text5"))
      .max(14, t("warning.text0")),
    time: yup.string().required(t("warning.text6")),
  });

  const monthReservationScheme = yup.object().shape({
    fromDate: yup
      .date()
      .typeError(t("warning.text1"))
      .nullable()
      .required(t("warning.text2")),
    // .min(new Date(), "Date must be in the future"),

    // yup.string().required("Date is required"),
  });

  const extendReservationScheme = yup.object().shape({
    numOfDays: yup
      .number()
      .typeError(t("warning.text3"))
      .nullable()
      .required(t("warning.text4"))
      .min(1, t("warning.text5"))
      .max(14, t("warning.text0")),
  });

  return {
    dailyReservationScheme,
    monthReservationScheme,
    extendReservationScheme,
  };
};
